import customAxios from './axios';
import CONFIG from '../../config';

export const getAllRefunds = () => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetAll`).then(res => {
        let response = res['data'];
        return response;
    })
}

export const getAllPaymentRefundReasons = () => {
    return customAxios.get(CONFIG.apiURL + `/paymentRefundReasons/GetAll`).then(res => {
        let response = res['data'];
        return response;
    })
}

export const getCsv = () => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetCsv`).then(res => {
        return res;
    })
}